<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing String Source</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <h6 class="text-uppercase" i18n>DRB Item Details</h6>
    <dl class="row small">
      <dt class="col-2" i18n>ID</dt>
      <dd class="col-10">{{ xliff.id }}</dd>
      <dt class="col-2" i18n>Version</dt>
      <dd class="col-10">{{ xliff.version }}</dd>
      <dt class="col-2" i18n>Source</dt>
      <dd class="col-10">{{ xliff.source }}</dd>
      <dt class="col-2" i18n>Note</dt>
      <dd class="col-10">{{ xliff.note }}</dd>
      <dt class="col-2" i18n>Created by</dt>
      <dd class="col-10">{{ xliff.created_by }}</dd>
      <dt class="col-2" i18n>Created on</dt>
      <dd class="col-10">{{ utility.convertUnixTime_global(xliff.created_ts) }}</dd>
      <dt class="col-2" i18n>Last updated by</dt>
      <dd class="col-10">{{ xliff.last_updated_by }}</dd>
      <dt class="col-2" i18n>Last updated on</dt>
      <dd class="col-10">{{ utility.convertUnixTime_global(xliff.last_updated_ts) }}</dd>
    </dl>
    <div class="row">
      <h6 class="text-uppercase" i18n>Translations</h6>
      <dl class="row small" *ngFor="let language of translationLanguages | keyvalue : descOrder">
        <app-string-translation [editable]="false" [language]="language" [xliff]="xliff"></app-string-translation>
      </dl>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton status="info" (click)="close()" i18n>Close</button>
    </div>
  </nb-card-footer>
</nb-card>
